<template>
  <div class="main-container" ref="container">
    <!-- 当前问题 -->
    <div class="current-question" v-if="currentQuestion">
      <div class="text">
        {{ currentQuestion }}
      </div>
    </div>
    <!-- 对话框区域 -->
    <display ref="display" @done="handleDone" @question="getQuestion" />
    <!-- <div class="tips" ref="tips">
      <div
        class="tips-item"
        v-for="(item, index) in questions"
        :key="index"
        @click="send(item.content)"
      >
        {{ item.content }}
      </div>
    </div> -->
    <!-- 发言区域 -->
    <div class="input-area">
      <div class="send-main">
        <a-textarea
          placeholder="输入内容开始聊天..."
          v-model="question"
          :auto-size="{ minRows: 2, maxRows: 3 }"
          @pressEnter="send()"
          @focus="handleFocus"
          @blur="handleBlur"
        />
        <a-icon class="send" type="stop" @click="stopChat" v-if="loading" />
        <span @click="send()" class="send-but" v-else>
          <!-- <svg-icon class="send" icon="send" color="#188164" /> -->
          发送
          <img src="~@/assets/images/send_icon.png" alt="" />
        </span>
      </div>
      <span class="toast-text">内容由 AI 生成，请仔细甄别</span>
    </div>
  </div>
</template>

<script>
import Display from "./display.vue";
export default {
  components: {
    Display,
  },
  data() {
    return {
      question: "",
      loading: false,
      currentQuestion: "",
      questions: [],
      typingSpeed: 30,
      showSettingsModal: false,
    };
  },
  created() {
    // 从本地存储中恢复打字速度设置
    const savedSpeed = localStorage.getItem(
      `${process.env.VUE_APP_NAME}:typing_speed`,
    );
    if (savedSpeed) {
      this.typingSpeed = parseInt(savedSpeed);
    }
  },
  methods: {
    handleDone() {
      this.loading = false;
    },
    getQuestion(q) {
      this.questions = q;
    },
    send(q) {
      console.log(q, this.question);
      if (this.loading) return;
      const content = q || this.question;
      if (!content || !content.trim()) {
        return;
      }
      this.loading = true;
      this.currentQuestion = content.trim();
      this.question = "";
      this.$refs.display.send(content);
    },
    stopChat() {
      this.$refs.display.stopChat();
    },
    handleFocus() {
      this.$emit("focusIn", this.$refs.display.scroll);
    },
    handleBlur() {
      this.$emit("focusOut", this.$refs.display.scroll);
    },
  },
};
</script>

<style lang="less" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: url("@/assets/images/mobil_bg.png") no-repeat center / cover;
  .tips {
    position: absolute;
    display: flex;
    bottom: 3rem;
    white-space: nowrap;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
      display: none;
    }
    &-item {
      display: inline-block;
      margin-right: 4px;
      background-color: white;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      padding: 0 5px;
      font-size: 12px;
      width: max-content;
    }
  }
  .input-area {
    height: max-content;
    // position: absolute;
    // bottom: 0;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .send-main {
      position: relative;
      border-radius: 1rem;
      padding: 15px;
      background-color: #fff;
      ::v-deep {
        textarea.ant-input {
          border: none;
          font-size: 1.2rem;
          z-index: 1;
        }
      }
      .send-but {
        display: block;
        color: #bebece;
        padding: 10px 30px;
        font-size: 1.2rem;
        cursor: pointer;
        margin-left: auto;
        width: max-content;
        margin-top: 10px;
        border-radius: 30px;
        border: 1px solid #bebece;
        img {
          width: 25px;
          margin-left: 10px;
          object-fit: contain;
        }
      }
      .send {
        position: absolute;
        bottom: 17px;
        right: 15px;
        z-index: 2;
        margin-left: 8px;
        color: red;
        font-size: 2rem;
      }
    }
    .toast-text {
      font-size: 1rem;
      display: block;
      margin: 10px 0;
      color: rgba(255, 255, 255, 0.4);
    }
  }
  .current-question {
    padding: 0 20px;
    .text {
      font-size: 1.2rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      padding: 15px;
      border-radius: 10px;
      background-color: #17405f;
      color: #8cffeb;
    }
  }
  .settings-button {
    position: fixed;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
  }
}

.settings-content {
  padding: 10px 0;
}

.setting-item {
  margin-bottom: 16px;
}

.setting-label {
  margin-bottom: 8px;
  font-weight: 500;
}

.setting-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
